import FeatureIcon, {
  type FeatureIconProps
} from '@nespresso/catalog-components-react/controls/FeatureIcon';
import type { Product } from '@/domain/Product';
import styles from './CoffeeCupSizesAndRecipes.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Translations, Options } from '@/widgets/ProductList/config';
import { type PropertySpecification } from '@/domain/Specification';
import {
  productCupSizeSpecToFeatureIcons,
  getRecipeIconDetails
} from '@/widgets/utils/FeatureIconsLookup.ts';
import useWidgetOptions from '@/widgets/hooks/useWidgetOptions.tsx';

export interface CoffeeCupSizesAndRecipesProps {
  product: Product;
}

export default function CoffeeCupSizesAndRecipes({
  product
}: CoffeeCupSizesAndRecipesProps) {
  const { t } = useTranslations<Translations>();
  const cupSizes = product.specifications.cupSizes as PropertySpecification[];
  const recipes = product.specifications.recipes as PropertySpecification[];

  const {
    cupSizeDisplayFormat,
    cupSizeVolumeUnits,
    cupSizeVolumesDecimalRounding
  } = useWidgetOptions<Options>();

  const featureIcons: FeatureIconProps['icons'] =
    productCupSizeSpecToFeatureIcons(cupSizes ?? [], {
      preferredUnits: cupSizeVolumeUnits,
      showIcon: cupSizeDisplayFormat.includes('icon'),
      showCupSizeName: cupSizeDisplayFormat.includes('label'),
      showLiquidVolume: cupSizeDisplayFormat.includes('volume'),
      decimalRounding: cupSizeVolumesDecimalRounding
    });

  if (
    (!Array.isArray(cupSizes) || cupSizes.length === 0) &&
    (!Array.isArray(recipes) || recipes.length === 0)
  ) {
    return null;
  }

  const recipeIcons: FeatureIconProps['icons'] = recipes
    ? getRecipeIconDetails(recipes)
    : [];

  return (
    <section class={styles.container}>
      <h2 class={styles.heading}>
        {t('productList.quickView.coffeeCupSizesAndRecipes.headingText')}
      </h2>
      <FeatureIcon
        icons={[...featureIcons, ...recipeIcons]}
        className={styles.featureIcons}
      />
    </section>
  );
}
